import React from 'react';
import RadioInput from '../../../shared/input/RadioInput';
import Modal from '../../../shared/modal/Modal';
import ModalFooter from '../../../shared/modal/ModalFooter';
import ModalHeader from '../../../shared/modal/ModalHeader';
import { ModalBody } from '../../../styled/Modal';
function FSExportModal(props) {
    var title = props.title, expandedOnly = props.expandedOnly, loading = props.loading, onConfirm = props.onConfirm, onChange = props.onChange;
    return (React.createElement(Modal, null,
        React.createElement(ModalHeader, { title: title }),
        React.createElement(ModalBody, null,
            React.createElement(RadioInput, { action: function () { return onChange(!expandedOnly); }, checked: expandedOnly, category: "expandedOnly", label: "Export currently expanded rows" }),
            React.createElement(RadioInput, { action: function () { return onChange(!expandedOnly); }, checked: !expandedOnly, category: "expandedOnly", label: "Export all rows" })),
        React.createElement(ModalFooter, { done: onConfirm, cancelLabel: "Close", loading: loading })));
}
export default FSExportModal;
